import Navbar from "../../components/Navbar";
import Hero from "../../components/Hero";
import Stats from "../../components/Stats";
import Features from "../../components/Features";
import LearningJourney from "../../components/LearningJourney";
import PlatformPreview from "../../components/PlatformPreview";
import Benefits from "../../components/Benefits";
import Testimonials from "../../components/Testimonials";
import FAQ from "../../components/FAQ";
import CTA from "../../components/CTA";

function Home() {
  return (
    <main className="bg-slate-950 text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <Stats />
      <Features />
      <LearningJourney />
      <PlatformPreview />
      <Benefits />
      <Testimonials />
      <FAQ />
      <CTA />
    </main>
  );
}

export default Home;